import {
  ChronoUnit,
  Device,
  ScheduledEventMutationPayload,
  ScheduleEventDeviceConfig,
} from '@thingslog/repositories';
import { format } from 'date-fns';

interface ScheduledEventFormInterface {
  eventName: string;
  fromDate: Date;
  toDate: Date;
  repeat: boolean;
  period: number | null;
  temporal: ChronoUnit | null;
  executionHour: number;
  executionMinute: number;
  event: ScheduleEventDeviceConfig;
  allDevices: Device[];
}

export class ScheduledEventForm implements ScheduledEventFormInterface {
  public eventName: string;
  public fromDate: Date;
  public toDate: Date;
  public repeat: boolean;
  public period: number | null;
  public temporal: ChronoUnit | null;
  public executionHour: number;
  public executionMinute: number;
  public event: ScheduleEventDeviceConfig;
  public allDevices: Device[];

  public constructor(data: ScheduledEventFormInterface) {
    this.eventName = data.eventName;
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
    this.repeat = data.repeat;
    this.period = data.period;
    this.temporal = data.temporal;
    this.executionHour = data.executionHour;
    this.executionMinute = data.executionMinute;
    this.event = data.event;
    this.allDevices = data.allDevices;
  }

  public toPayload(companyId: number): ScheduledEventMutationPayload {
    if (this.repeat === false) {
      this.period = null;
      this.temporal = null;
    }
    return {
      companyId,
      eventName: this.eventName,
      startDate: format(this.fromDate, 'yyyy-MM-dd'),
      endDate: format(this.toDate, 'yyyy-MM-dd'),
      executionTime: this.executionTime,
      repeat: this.repeat,
      period: this.period,
      temporal: this.temporal,
      scheduleEventDeviceConfig: this.event,
    };
  }

  private get executionTime(): string {
    const date = new Date(0, 0, 0, this.executionHour, this.executionMinute, 0);
    return format(date, 'HH:mm:ss');
  }
}
